import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwBox1,
  SpecificatieLoon
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {BehaviorSubject} from "rxjs";


@Component({
  selector: 'snelstart-venture-fiscaal-feature-rapport',
  templateUrl: './rapport.component.html',
  styleUrls: ['./rapport.component.scss'],
})
export class RapportComponent {
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    rapportFormGroup = this.fb.group<AangifteRapport>({});
    rapport = {} as AangifteRapport;

    public dialogBerekeningenVisible = false;
    showDialogBerekeningen() {
        this.dialogBerekeningenVisible = true;
    }
    public dialogSpecInkomenBox1Visible = false;
    showDialogSpecInkomenBox1() {
        this.dialogSpecInkomenBox1Visible = true;
    }
    public dialogSpecWUOVisible = false;
    showDialogSpecWUO() {
        this.dialogSpecWUOVisible = true;
    }
    public dialogSpecJaarrekeningVisible = false;
    showDialogSpecJaarrekening() {
        this.dialogSpecJaarrekeningVisible = true;
    }
    public dialogSpecLoonVisible = false;
    showDialogSpecLoon() {
        this.dialogSpecLoonVisible = true;
    }
    public dialogSpecROWVisible = false;
    showDialogSpecROW() {
        this.dialogSpecROWVisible = true;
    }
    public dialogSpecPUVisible = false;
    showDialogSpecPU() {
        this.dialogSpecPUVisible = true;
    }
    public dialogSpecEWVisible = false;
    showDialogSpecEW() {
        this.dialogSpecEWVisible = true;
    }
    public dialogSpecLijfrenteVisible = false;
    showDialogSpecLijfrente() {
        this.dialogSpecLijfrenteVisible = true;
    }
    public dialogSpecBelastingBox1Visible = false;
    showDialogSpecBelastingBox1() {
        this.dialogSpecBelastingBox1Visible = true;
    }
    public dialogSpecInkomenBox2Visible = false;
    showDialogSpecInkomenBox2() {
        this.dialogSpecInkomenBox2Visible = true;
    }
    public dialogSpecBox2Visible = false;
    showDialogSpecBox2() {
        this.dialogSpecBox2Visible = true;
    }
    public dialogSpecBelastingBox2Visible = false;
    showDialogSpecBelastingBox2() {
        this.dialogSpecBelastingBox2Visible = true;
    }
    public dialogSpecBox3Visible = false;
    showDialogSpecBox3() {
        this.dialogSpecBox3Visible = true;
    }
    public dialogSpecBelastingBox3Visible = false;
    showDialogSpecBelastingBox3() {
        this.dialogSpecBelastingBox3Visible = true;
    }
    public dialogSpecInkomenBox3Visible = false;
    showDialogSpecInkomenBox3() {
        this.dialogSpecInkomenBox3Visible = true;
    }
    public dialogSpecPGAZorgkostenVisible = false;
    showDialogSpecPGAZorgkosten() {
        this.dialogSpecPGAZorgkostenVisible = true;
    }
    public dialogSpecPGAGiftenVisible = false;
    showDialogSpecPGAGiften() {
        this.dialogSpecPGAGiftenVisible = true;
    }
    public dialogSpecPGAScholingVisible = false;
    showDialogSpecPGAScholing() {
        this.dialogSpecPGAScholingVisible = true;
    }
    public dialogSpecOverigePGAVisible = false;
    showDialogSpecOverigePGA() {
        this.dialogSpecOverigePGAVisible = true;
    }
    public dialogSpecPVVVisible = false;
    showDialogSpecPVV() {
        this.dialogSpecPVVVisible = true;
    }
    public dialogSpecHeffingskortingenVisible = false;
    showDialogSpecHeffingskortingen() {
        this.dialogSpecHeffingskortingenVisible = true;
    }
    public dialogSpecVoorheffingenVisible = false;
    showDialogSpecVoorheffingen() {
        this.dialogSpecVoorheffingenVisible = true;
    }
    public dialogSpecVerliescompensatieVisible = false;
    showDialogSpecVerliescompensatie() {
        this.dialogSpecVerliescompensatieVisible = true;
    }
    public dialogSpecZvwVisible = false;
    showDialogSpecZvw() {
        this.dialogSpecZvwVisible = true;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.rapportFormGroup = this.fb.group<AangifteRapport>(({
            specificatieLoon: this.fb.group<SpecificatieLoon>(({
                opbouw: this.fb.group<OpbouwBox1>(({
                    loonUitTegenwoordigeDienstbetrekking: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekkingBuitenland: null as unknown as number,
                    loonUitVroegereDienstbetrekking: null as unknown as number,
                    loonUitVroegereDienstbetrekkingBuitenland: null as unknown as number,
                    reisaftrekOpenbaarVervoer: null as unknown as number,
                    vergoedingReisaftrek: null as unknown as number
                } as OpbouwBox1))
            } as SpecificatieLoon))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
        this.dataService.aangifteRapport.subscribe((value) => {
            this.rapport = value;
            this.rapportFormGroup.patchValue(this.rapport)
        });
            }
        });
    }
}


